<template>
<div class="tentacle_holder" :style="style">
    <TentaclePart v-for="(part, index) in this.partList" :key="index" :tentacle_id="part.tid" :num="part.num" :ref="part.ref" :elNum="part.elNum" :startingAngle="part.angle"/>
</div>
</template>

<script>
import TentaclePart from './TentaclePart.vue'
import { EventBus } from '../EventBus.js'

export default {
  components: {
    TentaclePart
  },
  data () {
    let pl = []
    for (var i = 0; i < this.length; i++) {
      pl.push({tid: this.tentacleId, num: 10 - this.length + i, ref: i, elNum: i, angle: (i === 0 ? this.angle : 0)})
    }
    let style = {left: `${this.x}px`, top: `${this.y}px`}
    return {
      partList: pl,
      style: style
    }
  },
  props: { length: {
    type: Number,
    required: true
  },
  angle: {
    type: Number,
    required: true
  },
  x: {
    type: Number,
    required: true
  },
  y: {
    type: Number,
    required: true
  },
  tentacleId: {
    type: Number,
    required: true
  }
  },
  mounted () {
    EventBus.$on('tentacle-part-rotated', dat => {
      this.animate(dat.part)
    })
  },
  methods: {
    animate (target) {
      // let part = this.$refs[target.elNum]
      let part = target
      let child = this.$refs[target.elNum + 1]
      let m = part.parentMatrix.concat(part.matrix)
      if (child) {
        child[0].parentMatrix = m
      }
      m.applyToElement(target.element)
    }
  }
}
</script>

<style>
.tentacle_holder {
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Tentacle.vue